var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 19.061C8.46131 19.061 5.41108 17.0787 2.86829 12.811C5.41108 8.54335 8.46131 6.56104 12 6.56104C15.5387 6.56104 18.5889 8.54335 21.1317 12.811C18.5889 17.0787 15.5387 19.061 12 19.061ZM12 5.06104C7.63999 5.06104 4.09715 7.62961 1.34883 12.4389C1.21706 12.6695 1.21706 12.9526 1.34883 13.1832C4.09715 17.9925 7.63999 20.561 12 20.561C16.36 20.561 19.9028 17.9925 22.6512 13.1832C22.7829 12.9526 22.7829 12.6695 22.6512 12.4389C19.9028 7.62961 16.36 5.06104 12 5.06104ZM10.75 12.811C10.75 12.1207 11.3096 11.561 12 11.561C12.6904 11.561 13.25 12.1207 13.25 12.811C13.25 13.5014 12.6904 14.061 12 14.061C11.3096 14.061 10.75 13.5014 10.75 12.811ZM12 10.061C10.4812 10.061 9.25 11.2923 9.25 12.811C9.25 14.3298 10.4812 15.561 12 15.561C13.5188 15.561 14.75 14.3298 14.75 12.811C14.75 11.2923 13.5188 10.061 12 10.061Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye_icon.ef2a75b430f8e479464ea8e918c7b7c8.svg";
export { ForwardRef as ReactComponent };